import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core'
import {provideRouter, withHashLocation} from '@angular/router'

import {routes} from './app.routes'
import {
  provideAnimationsAsync
} from '@angular/platform-browser/animations/async'
import {registerLocaleData} from '@angular/common'
import localeFrExtra from '@angular/common/locales/extra/fr'
import localeSvExtra from '@angular/common/locales/extra/sv'
import localeFr from '@angular/common/locales/fr'
import localeSv from '@angular/common/locales/sv'
import {provideHttpClient, withInterceptors} from '@angular/common/http'
import {authInterceptor} from './application/auth-interceptor'
import {responseInterceptor} from './application/response-interceptor'
import {LOCAL_STORAGE} from './application/injection-tokens'
import {BootstrapService} from './services/bootstrap.service'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MAT_EXPANSION_PANEL_DEFAULT_OPTIONS} from '@angular/material/expansion'

registerLocaleData(localeFr, 'fr', localeFrExtra)
registerLocaleData(localeSv, 'sv', localeSvExtra)

const bootstrapFactory = (bs: BootstrapService) => bs.init()

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => bootstrapFactory(inject(BootstrapService))),
    {provide: LOCALE_ID, useValue: 'sv-SE'},
    {provide: LOCAL_STORAGE, useValue: localStorage},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        color: 'accent',
        appearance: 'fill',
        floatLabel: 'always',
        subscriptSizing: 'dynamic'
      }
    },
    {
      provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
      useValue: {expandedHeight: '75px', collapsedHeight: '75px'}
    },
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withHashLocation()),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([authInterceptor, responseInterceptor])
    )
  ]
}
